import { PropsWithChildren, Suspense } from 'react';

import { Loader } from '../../Loader/Loader.component';

import styles from './ModalContent.module.scss';
import { ModalContentProps } from './ModalContent.types';

export const ModalContent = ({
  header,
  title,
  description,
  titleBarActions,
  children,
}: PropsWithChildren<ModalContentProps>) => {
  return (
    <>
      <div className={styles.header}>{header}</div>
      <div className={styles.content}>
        <div className={styles.titleBar}>
          <div className={styles.titleBarContent}>
            <div className={styles.title}>{title}</div>
            <div>{description}</div>
          </div>
          <div className={styles.titleBarActions}>{titleBarActions}</div>
        </div>
        <div className={styles.children}>
          <Suspense fallback={<Loader size="medium" />}>{children}</Suspense>
        </div>
      </div>
    </>
  );
};
